import {useNavigate} from "react-router-dom";
import {useContext} from "react";
import {ChangesContext, ToastContext} from "../Contexts";
import {
    Post,
    ToastFailureMessage,
    ToastSuccessMessage, PostFilterRequest, PostFilterResponse, PostGetRequest
} from "../Models/Models";
import HttpRepository from "./HttpRepository";

export function PostService() {
    const navigate = useNavigate()
    let {setToast}: any = useContext(ToastContext);
    let { setHasChanges } : any = useContext(ChangesContext);

    async function createPost(post: Post): Promise<void> {
        try {
            const response = await HttpRepository.createPost(post);
            if (response.data.hasFrontendChanges)
                setHasChanges(true);
        }
        catch (error) {
            setToast({message: ToastFailureMessage.dataNotSaved});
            return;
        }

        setToast({message: ToastSuccessMessage.dataSaved});
        navigateToPostTable();
    }

    async function getPost(request: PostGetRequest): Promise<Post> {
        try {
            return (await HttpRepository.getPost(request)).data;
        }
        catch (error) {
            setToast({message: ToastFailureMessage.dataNotLoaded});
        }
    }

    async function filterPosts(request: PostFilterRequest): Promise<PostFilterResponse> {
        try {
            return (await HttpRepository.filterPosts(request)).data;
        }
        catch (error) {
            setToast({message: ToastFailureMessage.dataNotLoaded});
        }
    }

    async function updatePost(post: Post): Promise<void> {
        try {
            const response = await HttpRepository.updatePost(post);
            if (response.data.hasFrontendChanges)
                setHasChanges(true);
        }
        catch (error) {
            setToast({message: ToastFailureMessage.dataNotSaved});
            return;
        }

        setToast({message: ToastSuccessMessage.dataSaved});
        navigateToPostTable();
    }

    async function deletePost(id: number) {
        try {
            const response = await HttpRepository.deletePost(id);
            if (response.data.hasFrontendChanges)
                setHasChanges(true);
        }
        catch (error) {
            setToast({message: ToastFailureMessage.changesNotSaved});
            return;
        }

        setToast({message: ToastSuccessMessage.changesSaved});
        navigateToPostTable();
    }

    const navigateToPostTable = () => {
        navigate("/post/table");
    };

    return {filterPosts, createPost, getPost, updatePost, deletePost}
}